import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CouponService } from '../../services/coupon.service';
import { FirebaseMessage } from '../../services/firebasemessages';
import { FormBuilder, FormGroup, } from '@angular/forms'
import { menurolesService } from '../../services/menuroles.service';
@Component({
  selector: 'app-assgin-messages',
  templateUrl: './assgin-messages.component.html',
  styleUrls: ['./assgin-messages.component.scss']
})
export class AssginMessagesComponent implements OnInit {
  public isPageEditable: boolean = false;
  public isdisplayByPatient: boolean = true;
  public isdisplayByCoupons: boolean = false;
  public searchBySelected: boolean = false;
  public SelectAll: boolean = false;
  searchValue: string = '';
  public patientList: any[];
  private patientLength : any = '';
  searchByList = [
    { id: 1, name: "Age" },
    { id: 2, name: "Insurance" },
    { id: 3, name: "Mobile" },
    { id: 4, name: "Email" },
    { id: 5, name: "Name" },
  ];
  public messageSelectList: any[];
  public coupons: any[]
  public searchBySelectedID: any;
  public selectedMessageid: number = -1;
  public isSlide: boolean = false;
  messgageForm: FormGroup;
  messageSelectedType = true;
  constructor(private fb: FormBuilder, private firebaseMessage: FirebaseMessage, private _couponService: CouponService, private _menurolesService: menurolesService) {
    this.selectedMessageid = -1;
    this.messgageForm = fb.group({
      messageType: [true],
      selectedMessageid: ['',],
      messagesSelectList: [],
    })

  }

  ngOnInit() {
    this.getPatientsList();
    this.isPageEditable = this._menurolesService.getpageAcessbility();
    this.messageSelectedType = this.messgageForm.get('messageType').value;
    this.getAllMessages(this.messageSelectedType);
  }
  selectType(value) {
    this.getAllMessages(value);
  }
  getPatientsList() {
    this.patientList = [];
    this.isdisplayByPatient = true;
    this.isdisplayByCoupons = false;
    let itemsPerPage = 5;
    let page = 1;
    this.firebaseMessage.getPatientsFirebaseMessageList(this.selectedMessageid, itemsPerPage, page)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = employeeData.response.patientList;
            this.patientLength = this.patientList.length;
            debugger;
            console.log('length ', this.patientLength);
            debugger;
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  getAllMessages(type) {
    this.firebaseMessage.getMessagesByType(type)
      .subscribe(
        (data) => {
          if (data.response == null) {
            this.messageSelectList = [];
          }
          else {
            this.messageSelectList = data.response;
            this.selectedMessageid = this.messageSelectList[0].id
            this.getPatientsListbyMessageId(this.selectedMessageid)
          }
          console.log(this.messageSelectList);
        },
        (error) => {
          // this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  assignCoupons() {
    this._couponService.getcoupans()
      .subscribe(
        (couponData) => {
          if (couponData.response == null) {
            this.messageSelectList = null
          }
          else {
            this.messageSelectList = couponData.response.couponList

          }
          console.log(this.messageSelectList);
        },
        (error) => {
          // this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  selectOption(id: number) {
    console.log(id)
    this.selectedMessageid = id;
    this.getPatientsListbyMessageId(this.selectedMessageid)
  }
  searchOption(id: number) {
    this.searchValue = '';
    this.getPatientsListbyMessageId(this.selectedMessageid);
    this.searchBySelectedID = id;
    if (id > 0) {
      this.searchBySelected = true;
    } else {
      this.searchBySelected = false;
    }
  }

  getPatientsListbyMessageId(selectedMessageid) {
    this.isdisplayByPatient = true;
    this.isdisplayByCoupons = false;
    let itemsPerPage = 5;
    let page = 1;
    this.firebaseMessage.getPatientsFirebaseMessageList(this.selectedMessageid, itemsPerPage, page)
      .subscribe(
        (data) => {
          if (data == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = data.response.patientList
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  assignMessage(userdata) {
    let confimationMessage = userdata.IsSlotAssign == true ? "Are you sure want to Unassigned " + userdata.patientName : "Are you sure want to Assigned " + userdata.patientName;
    if (confirm(confimationMessage)) {
      if (this.selectedMessageid) {
        this.firebaseMessage.assignMessage(userdata, this.selectedMessageid).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("Messages records save Sucessfully")
              this.getPatientsList();
            }
            else {
              alert(data.returnMsg)
              this.getPatientsList();
            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Please select a message")
        return;
      }
    }
    else {
    }

  }
  assignMessageAll() {
    //debugger;
    if (confirm("Are you sure to send all?")) {
      this.SelectAll = true;
      if (this.selectedMessageid) {
        let result = this.patientList.map(a => a.Id);
       // debugger
        this.firebaseMessage.assignMessageAll(result, this.selectedMessageid).subscribe(
          
          data => {
            if (data.returnCode == 0) {
              alert("Messages records save Sucessfully")
              this.getPatientsList();
              this.SelectAll = false;
            }
            else {
              alert(data.returnMsg)
              this.getPatientsList();
            }
          },
          error => {
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Please select a message")
        return;
      }
    }
    else {
    }

  }

  onSearchChange(searchValue: string) {
    searchValue = searchValue.toLowerCase();
    searchValue = searchValue.trim();
    let itemsPerPage = 5;
    let page = 1;
    this.firebaseMessage.getPatientsFirebaseMessageList(this.selectedMessageid, itemsPerPage, page)
      .subscribe(
        (data) => {
          if (data == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            this.patientList = data.response.patientList.filter(t => (t.patientName != null && t.patientName.toLowerCase().indexOf(searchValue) > -1) || (t.email != null && t.email.toLowerCase().indexOf(searchValue) > -1) || (t.mobile != null && t.mobile.indexOf(searchValue) > -1) || (t.insuranceCompany != null && t.insuranceCompany.toLowerCase().indexOf(searchValue) > -1) || (t.patientAge != null && t.patientAge == parseInt(searchValue)));
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  onSearchBy(searchValue: string) {
    searchValue = searchValue.toLowerCase();
    searchValue = searchValue.trim();
    this.searchValue = searchValue;
    let itemsPerPage = 5;
    let page = 1;
    this.firebaseMessage.getPatientsFirebaseMessageList(this.selectedMessageid, itemsPerPage, page)
      .subscribe(
        (data) => {
          if (data == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else {
            if (this.searchBySelectedID == '1') {
              this.patientList = data.response.patientList.filter((t) => {
                return (t.patientAge != null && t.patientAge == parseInt(this.searchValue))
              });
            }
            if (this.searchBySelectedID == '2') {
              this.patientList = data.response.patientList.filter(t => (t.insuranceCompany != null && t.insuranceCompany.toLowerCase().indexOf(this.searchValue) > -1));
            }
            if (this.searchBySelectedID == '3') {
              console.log('dfdfdf')
              this.patientList = data.response.patientList.filter(t => (t.mobile != null && t.mobile.indexOf(this.searchValue) > -1));
              console.log(this.patientList)
            }
            if (this.searchBySelectedID == '4') {
              this.patientList = data.response.patientList.filter(t => (t.email != null && t.email.toLowerCase().indexOf(this.searchValue) > -1));
            }
            if (this.searchBySelectedID == '5') {
              this.patientList = data.response.patientList.filter(t => (t.patientName != null && t.patientName.toLowerCase().indexOf(this.searchValue) > -1));
            }

          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }

  onPageChange(data){
    console.log('check ', data.activePage);
    let page = data.activePage;
    let itemsPerPage = data.activePage * 5;
    let lastCounter = (parseInt(this.patientLength)/itemsPerPage)+1;
    if(page == lastCounter){
      this.firebaseMessage.getPatientsFirebaseMessageList(this.selectedMessageid, itemsPerPage, page)
      .subscribe(
        (employeeData) => {
          console.log('data fetched ', employeeData);
          if (employeeData.response == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else if(employeeData.returnCode != 10){
            this.patientList.push(employeeData.response.patientList);
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
    }
    else{
      this.firebaseMessage.getPatientsFirebaseMessageList(this.selectedMessageid, itemsPerPage, page)
      .subscribe(
        (employeeData) => {
          console.log('data fetched ', employeeData);
          if (employeeData.response == null) {
            //this.statusMessage = "Patients does not exist..";
          }
          else if(employeeData.returnCode != 10){
            this.patientList.push(employeeData.response.patientList);
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/assgin-messages/assgin-messages.component.ts